Moderation.Views ||= {}

class Moderation.Views.ModerationSessionView extends Backbone.View
  template: JST["backbone/templates/moderation/session"]
  tagName: 'tr'
  className: 'session-entry'

  initialize: (@options = {}) ->
    @session = @options.session
    @current_account = @options.current_account
    @addUrls(@session)

  render: =>
    @$el.html(@template({ session: @session}))
    @$el.find('.blocked').css("visibility", "visible") if @session.blocked_count
    @$el.find('.moderation-time').css("visibility", "visible") if @session.last_moderation_date
    @$el.find('.moderate').css("visibility", "visible") if @canModerate()
    return this

  canModerate: ->
    @session.enqueued_count > 0 && @session.blocked_count < @session.enqueued_count

  addUrls: (session) ->
    prefix = if session.type == 'review_queue' then '/moderation/dashboard/review_queue' else '/moderation/dashboard/session'
    session.url = "#{prefix}?id=#{session.id}&account_id=#{@current_account}&new_account_id=#{session.account_id}"
